import { render, staticRenderFns } from "./FooterComponentGlobal.vue?vue&type=template&id=ceebda5e&scoped=true&"
import script from "./FooterComponentGlobal.vue?vue&type=script&lang=js&"
export * from "./FooterComponentGlobal.vue?vue&type=script&lang=js&"
import style0 from "./FooterComponentGlobal.vue?vue&type=style&index=0&id=ceebda5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceebda5e",
  null
  
)

export default component.exports